import { Form, Radio, theme, Typography } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const Drainagestelsel = () => {
  const { t } = useTranslation('input');
  const form = Form.useFormInstance();
  const { token } = theme.useToken();
  const jaar = Form.useWatch('registratiejaar', { form, preserve: true });
  const [aanwezig, setAanwezig] = useState<boolean>();
  if (Number(jaar) < 2026 || jaar == null) return null;
  return (
    <>
      <Typography.Title level={5}>
        {t('form.groundEmission.drainage.title')}
      </Typography.Title>
      <Typography.Paragraph id="drainagestelsel-question">{t('form.groundEmission.drainage.question')}</Typography.Paragraph>
      <Radio.Group
        aria-labelledby="drainagestelsel-question"
        value={aanwezig}
        onChange={event => setAanwezig(event.target.value)}
        options={[
          { label: t('form.groundEmission.drainage.yes'), value: true },
          { label: t('form.groundEmission.drainage.no'), value: false },
        ]}
      />
      <br /><br />
      {aanwezig !== undefined && <Typography.Paragraph>{t(`form.groundEmission.drainage.${aanwezig ? 'yesInfo' : 'noInfo'}`)}</Typography.Paragraph>}
    </>
  );
};
